import script from "./register_complete.vue?vue&type=script&setup=true&lang=js"
export * from "./register_complete.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__